import React from 'react';
import './Client.css';

const Client = () => {
  return (
    <section id="clients" className="clients-section">
      <div className="container">

        <div className="clients-header">
          <h2>Technology Partners</h2>

          <p>
            Trusted by leading platforms and delivered alongside
            best-in-class technology partners.
          </p>
        </div>

        <div className="partners-wrapper">

          <div className="partner-item">
            <a
             href="https://www.microsoft.com"
             target="_blank"
            rel="noopener noreferrer"
            className="partner-link"
          >
         <img
            src="/images/microsoft.png"
            alt="Microsoft"
         />

         <span>Microsoft</span>
        </a>
          </div>

          <div className="partner-item">
            <a
             href="https://www.databricks.com"
             target="_blank"
            rel="noopener noreferrer"
            className="partner-link"
          >
         <img
            src="/images/databricks.PNG"
            alt="Databricks"
         />

            <span>Databricks</span>
          </a>
          </div>

          <div className="partner-item">
            <a
             href="https://www.servicenow.com/"
             target="_blank"
            rel="noopener noreferrer"
            className="partner-link"
          >
         <img
            src="/images/servicenow.PNG"
            alt="serviceNow"
         />

            <span>serviceNow</span>
          </a>
          </div>

          <div className="partner-item">
            <a
             href="https://www.e-assessment.com/"
             target="_blank"
            rel="noopener noreferrer"
            className="partner-link"
          >
         <img
            src="/images/eaa.PNG"
            alt="e-Assessment Association"
        />

            <span>e-Assessment Association</span>
          </a>
          </div>

          <div className="partner-item">
            <a
             href="https://www.sap.com/india/index.html"
             target="_blank"
            rel="noopener noreferrer"
            className="partner-link"
          >
         <img
            src="/images/sap.png"
            alt="SAP"
         />

            <span>SAP</span>
          </a>
          </div>

        </div>

      </div>
    </section>
  );
};

export default Client;
